<template>
  <div class="page-wrapper">
    <the-email-header />

    <div class="center-content">
      <v-loader v-if="loader" />
      <h4 v-else class="text-center">{{ message }}</h4>
    </div>
  </div>
</template>

<script setup name="TheEmailDeclineTemplate">
import { onMounted, onUnmounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import api from "@/api";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import TheEmailHeader from "@/components/email/TheEmailHeader.vue";

const route = useRoute();
const { locale, t } = useI18n();
let savedLocale = null;
const loader = ref(false);
const message = ref("");

const decline = async () => {
  const { caseid, token, resources } = route.query;
  loader.value = true;
  try {
    const resourceIds = typeof resources === "string" ? resources.split(",").map(Number) : [];

    const payload = {
      resourceIds,
    };
    await api.case.declineEmail(caseid, token, payload);
    message.value = t("general.pages.supplierAnswerThanks");
  } catch (error) {
    console.error(error);
    message.value = t("general.pages.supplierAnswerError");
  } finally {
    loader.value = false;
  }
};

onMounted(() => {
  const { lang } = route.query;
  if (lang) {
    savedLocale = locale.value;
    locale.value = lang;
  }
  decline();
});

onUnmounted(() => {
  if (savedLocale) {
    locale.value = savedLocale;
  }
});
</script>

<style>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.center-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
